module.exports = __webpack_public_path__ + "img/zlifeBlack.e1f35b87.png";